import get from "lodash-es/get";
import trim from "lodash-es/trim";
import { useState } from "react";

const normalized = (input: string) => trim(input).toLowerCase();

export const useTableDataFilter = <T>(data: T[], columns: string[]) => {
  const [searchQuery, setSearchQuery] = useState("");

  const normalizedSearchQuery = normalized(searchQuery);

  const filteredData = data.filter((d) => {
    const match = columns.find((c) => {
      const value = get(d, c) as string;

      return normalized(value).includes(normalizedSearchQuery);
    });

    return !!match;
  });

  return [searchQuery, setSearchQuery, filteredData] as const;
};
